import "antd/lib/checkbox/style";
import Checkbox from "antd/lib/checkbox";

export default Checkbox;
